const MS_PER_DAY = 86_400_000;

const ROLLING_WEEK_DAYS = 6;
const ROLLING_MONTH_DAYS = 29;
const ROLLING_QUARTER_DAYS = 89;
const ROLLING_YEAR_DAYS = 364;

const ISO_MONDAY = 1;
const ISO_SATURDAY = 6;
const ISO_SUNDAY = 7;
const DAYS_FROM_MONDAY_TO_FRIDAY = 3;
const DAYS_FROM_SATURDAY_TO_FRIDAY = 1;
const DAYS_FROM_SUNDAY_TO_FRIDAY = 2;

function daysAgo(from: Date, days: number): Date {
  return new Date(from.getTime() - days * MS_PER_DAY);
}

export function getRegistrationRanges(): Record<
  string,
  { start: Date; end: Date }
> {
  const now = new Date();
  const today = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  );
  const endOfToday = new Date(
    Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      23,
      59,
      59,
      999
    )
  );

  const jsDay = today.getUTCDay();
  const isoDay = jsDay === 0 ? ISO_SUNDAY : jsDay;

  let yesterdayRange: { start: Date; end: Date };
  if (isoDay === ISO_MONDAY) {
    const fri = daysAgo(today, DAYS_FROM_MONDAY_TO_FRIDAY);
    yesterdayRange = { start: fri, end: new Date(today.getTime() - 1) };
  } else if (isoDay === ISO_SATURDAY || isoDay === ISO_SUNDAY) {
    const daysToFri =
      isoDay === ISO_SATURDAY
        ? DAYS_FROM_SATURDAY_TO_FRIDAY
        : DAYS_FROM_SUNDAY_TO_FRIDAY;
    const friStart = daysAgo(today, daysToFri);
    yesterdayRange = {
      start: friStart,
      end: new Date(friStart.getTime() + MS_PER_DAY - 1),
    };
  } else {
    yesterdayRange = {
      start: daysAgo(today, 1),
      end: new Date(today.getTime() - 1),
    };
  }

  return {
    'registrations-week': {
      start: daysAgo(today, ROLLING_WEEK_DAYS),
      end: endOfToday,
    },
    'registrations-month': {
      start: daysAgo(today, ROLLING_MONTH_DAYS),
      end: endOfToday,
    },
    'registrations-quarter': {
      start: daysAgo(today, ROLLING_QUARTER_DAYS),
      end: endOfToday,
    },
    'registrations-year': {
      start: daysAgo(today, ROLLING_YEAR_DAYS),
      end: endOfToday,
    },
    'new-donors-yesterday': yesterdayRange,
  };
}
